import { render } from "./BuyTravelPass.vue?vue&type=template&id=84ce3450&lang=pug"
import script from "./BuyTravelPass.vue?vue&type=script&lang=ts"
export * from "./BuyTravelPass.vue?vue&type=script&lang=ts"

import "./BuyTravelPass.vue?vue&type=style&index=0&id=84ce3450&lang=scss"
script.render = render

export default script